var bighouse = bighouse || {};

bighouse.searchFilters = (function () {


    var checkin = {};

    function init() {
        updateCheckIn();
        bindSubcats();
        bindAll();
        bindEvents();
    }


    function bindAll(){
        $('.js-filterAllContainer').each(function(index){
            var thisFilterGroup = this;
            var filterGroup = $(this).find('input[type="checkbox"]');
            var parentCheckbox = filterGroup[0];

            $(filterGroup).on('click', function(){
                if(this === parentCheckbox){
                    $(this).prop('checked', true);
                    $(thisFilterGroup).find('input[type="checkbox"]:checked').not(parentCheckbox).prop('checked', false);
                } else {
                    var howManyChecked = $(thisFilterGroup).find('input[type="checkbox"]:checked').not(parentCheckbox).length;

                    if(howManyChecked > 0 )
                        $(parentCheckbox).prop('checked', false);
                    else
                        $(parentCheckbox).prop('checked', true);
                }
            });
        });
    }


    function bindSubcats(){
        $('.js-filterGroup').each(function(index){
            var thisFilterGroup = this;
            var filterGroup = $(this).find('input[type="checkbox"]');
            var parentCheckbox = filterGroup[0];

            $(filterGroup).on('click', function(){
                if(this === parentCheckbox){
                    //if checked then check all below
                    //if unchecked then uncheck all below
                    $(filterGroup).prop('checked',  $(this).prop('checked') );
                } else {
                    //if all are checked, make sure parent is also checked
                    //if not all are checked, make sure parent is unchecked
                    var howManyChecked = $(thisFilterGroup).find('input[type="checkbox"]:checked').not(parentCheckbox).length;

                    if(howManyChecked === (filterGroup.length-1)){
                        $(parentCheckbox).prop('checked', true);
                    } else {
                        $(parentCheckbox).prop('checked', false);
                    }
                }
            });
        });
    }


    function bindEvents(){
        $('.SearchFilters input[type="checkbox"]').on('change', updateFilters)
        $('.SearchHeader-sort select').on('change', updateFilters);

        $('.js-applyDates').on('click', function(e){
            updateCheckIn();
            updateFilters();
            e.preventDefault();
        });

        $('.js-searchReset').on('click', resetFilters);
    }


    function updateCheckIn(){
        checkin.date = $('input[name=datefrom]').val();
        checkin.nights = $('select[name=nights]').val();

        if(checkin.nights !== '-1'){
            $('.js-viewPriceBy').addClass('u-hide');
        } else {
            $('.js-viewPriceBy').removeClass('u-hide');
        }
    }

    function updateFilters(){

        if(  $('.Page-sidebar').width() === 0 ){ //sidebar width is zero therefore mobile view
            bighouse.pageSidebar.remoteCloseSidebar();
        }

        var form = $('#searchfilters').find('input').not('.js-filterAll');

        bighouse.searchTags.removeAllTags();

        var queryStr = checkCheckinDates(); //set tags and init query string
        checkRangeSize(); //set tags

        for(var i=0; i<form.length; i++){

            if( $(form[i]).prop('checked') || $(form[i]).attr('type') !== 'checkbox' ){

                var name =  $(form[i]).attr('name');
                var label = $(form[i]).parents('label').text().trim();
                var value = $(form[i]).val();

                if( label !== ''){
                    bighouse.searchTags.addTag(value, label, name);
                }

                queryStr += '&' + name + '=' +  escape(value);
            }
        }

        //queryStr = sortBy(queryStr);

        bighouse.searchTags.checkTagList();
        bighouse.searchTags.bindTagEvents();
        queryStr = queryStr.replace('&', '?'); //replace the first & with ?

        $('.js-searchError').addClass('u-hide');
        $('.Page-body .Wrapper').addClass('SearchResults-loadingSpinner');


        var localUrl = location.protocol + '//' + location.host + '/';
        console.log(localUrl);
        
        if (typeof window.apiUrl === 'undefined' || window.apiUrl === null || window.apiUrl === 'http://localhost/') {
            localUrl = 'https://big-house-experience-dev.azurewebsites.net/';
        }

        if (location.pathname != "/big-houses-for-rent") {
            console.log(location.pathname)
            window.location.href = localUrl + "big-houses-for-rent" + queryStr;
            return;
        }

        $.ajax({
            url: localUrl + 'umbraco/api/PropertiesListapi/Search' + queryStr,
            type: 'get',
            data: 'json',
            error: function (err) {
                //ADD ERROR
                console.log(err);
                $('.js-searchError').removeClass('u-hide');
            },
            success: function (data) {
                //ADD SUCCESS
                var jsonData = JSON.parse(data);

                updateUrlQueryStr(queryStr);
                updateInterface(jsonData.FilteredProperties, form);
                generateSearchListing(jsonData.FilteredProperties);
                bighouse.searchActiveFilters.setActiveFilters(jsonData.ActiveFilters);
            },
            complete: function(){
                $('.Page-body .Wrapper').removeClass('SearchResults-loadingSpinner');
            }
        });

    }



    function updateUrlQueryStr(queryStr){
        if (history.pushState) {
            let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryStr;
            window.history.pushState({ path: newurl }, '', newurl);
        }
    }



    function checkCheckinDates(){
        var queryStr = '';

        if(checkin.date !== "") {
            bighouse.searchTags.addTag(checkin.date, formatDate(checkin.date), 'datefrom');
            queryStr += '&datefrom=' +  checkin.date;
        }

        //value, label, name
        if(checkin.nights !== "-1"){
            bighouse.searchTags.addTag(checkin.nights, checkin.nights + ' Nights', 'nights');
            queryStr += '&nights=' +  checkin.nights;
        } else {
            //if nights aren't specified then use the dropdown
            queryStr +=  "&viewpriceby=" + $('#viewpriceby').val();
        }


        //regular sorting
        queryStr +=  "&orderby=" + $('#orderby').val();

        return queryStr;
    }


    const dateArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    function formatDate(date){

        var dateSplit = date.split('-');
        if(dateSplit.length === 3){
            return dateSplit[0] + ' ' + dateArray[ parseInt(dateSplit[1], 10)-1 ] + ' ' + dateSplit[2]
        } else {
            return date;
        }
    }

    function checkRangeSize() {
        checkRangeAndAddTag('.js-partyRangeSlider', 'partysizemin', 'partysizemax', 'Party Size');
        checkRangeAndAddTag('.js-bedroomsRangeSlider', 'bedroomsquantitymin', 'bedroomsquantitymax', 'Bedrooms Quantity');
    }
    
    function checkRangeAndAddTag(sliderSelector, minInputId, maxInputId, tagLabel) {
        let rangeMin = $(sliderSelector).attr('data-min');
        let rangeMax = $(sliderSelector).attr('data-max');
    
        if ($('#' + minInputId).val() !== rangeMin || $('#' + maxInputId).val() !== rangeMax) {
            bighouse.searchTags.addTag(minInputId, tagLabel, minInputId);
        }
    }


    function updateInterface(filteredProperties, form){
        //Total Count
        $('.js-searchTotal').html( filteredProperties.length );


        //if this is an SEO friendly page, remove the seo title on a filter change
        if($('.js-isSEOFriendly').length > 0){
            var reverted = $('.js-isSEOFriendly').attr('data-revertto');
            $('.js-isSEOFriendly').html(   $('.js-searchTotal')[0].outerHTML + ' ' + reverted);
            $('.js-isSEOFriendly').removeClass('js-isSEOFriendly').removeClass('SearchHeader-seoFriendly').removeAttr('data-revertto');
            
            $('.js-seoFriendlyText').addClass('u-hide');
        }


        //Pluralisation of title
        if(filteredProperties.length === 1)
            $('.js-searchTotalPlural').addClass('u-hide');
        else
            $('.js-searchTotalPlural').removeClass('u-hide');

        //No results panel
        if(filteredProperties.length === 0){
            bighouse.searchNoResults.updateNoResults(form);
            $('.js-searchNoResults').removeClass('u-hide');

            $('.js-filterStickyBtn').addClass('u-hide');
            $('.js-filterStickyBtn').parent('.SearchResults-stickyBtn').addClass('u-hide');

            $('.js-filterNoResultsBtn').removeClass('u-hide');
        } else {
            $('.js-searchNoResults').addClass('u-hide');
            $('.js-filterStickyBtn').removeClass('u-hide');
            $('.js-filterStickyBtn').parent('.SearchResults-stickyBtn').removeClass('u-hide');

            bighouse.search.resizeStickyFilter();

            $('.js-filterNoResultsBtn').addClass('u-hide');
        }

    }




    function resetFilters(e){
        $('input[name=datefrom]').val('');
        clearNights(true);
        updateCheckIn();

        $('#searchfilters').find('input').not('.js-filterAll').prop('checked', false);
        $('#searchfilters').find('.js-filterAll').prop('checked', true);

        bighouse.rangeSlider.resetPartySize();
        bighouse.rangeSlider.resetBedroomsQuantity();

        e.preventDefault();
    }


    function clearNights(disable){
        $('select[name=nights]').val('-1').attr('disabled', disable);
    }


    function generateSearchListing(results) {
        //get the template code - sold out / multi guest / normal & container
        var markup = "";
        var searchItem = $('#searchListing').html();


        $.each(results, function (index) {
            var self = this;

            var carouselSlides = generateCarouselSlides(self.ListingImage, self.PropertyUrl);
            var icons = generateIcons(self);

            var regionText = (self.County) ? self.County + ", " + self.Country : self.Country;

            var data = {
                "index" : index,
                "title": self.PropertyName,
                "region": regionText,
                "summary" : self.ListingDescription,
                "url" : self.PropertyUrl,
                //"breaktype" : self.PropertyPriceSummary.PPS_BreakType,
                //"price": self.PropertyPriceSummary.PPS_PriceFrom,
                "price": self.FormattedPrice,
                "duration": self.FormattedDuration,
                //"perperson" : self.PropertyPriceSummary.PPS_PricePerPerson,
                "manor" : self.HasChildProperties ? " (manor only)" : "",
                "icons" : icons,
                "images" : carouselSlides
            };
            var updatedString = util.template(searchItem, data);
            markup += updatedString;
        });

        $('.js-searchListing').html(markup);

        //all other carousels have gone. Reinit.
        bighouse.searchCarousel.init();
    }






    function generateIcons(results){
        var iconStr = '';

        iconStr += singularIcon(results.SleepsToolTip, "sleeps.svg", "vector of two people", "Sleeps", results.Sleeps, false );
        iconStr += singularIcon(results.BedroomsToolTip, "bedrooms.svg", "vector of a person in bed", "Bedrooms", results.Bedrooms, false );
        iconStr += singularIcon(results.BathroomsToolTip, "bathrooms.svg", "icon of a Bathtub", "Bathrooms", results.Bathrooms, false );

        if(results.PetFriendly){
            iconStr += singularIcon(results.PetFriendlyToolTip, "", "", "", results.Bathrooms, true );
        }

        return iconStr;
    }


    function singularIcon(tooltip, image, alttext, title, number, petfriendly){

        var toolTipStr = '<li><a href="#" class="Tooltip">{{content}}<div class="Tooltip-hover">{{tooltip}}</div></a></li>';
        var noToolTipStr = '<li><span>{{content}}</span></li>';
        var facilityStr = '<img src="/assets/img/icons/{{image}}" alt="{{alt}}"><span class="u-visuallyHidden">{{title}}:</span> <span>{{number}}</span>';

        var innerTemplate;
        var outerTemplateToUse = (tooltip !== undefined && tooltip !== '') ? toolTipStr : noToolTipStr;

        if(petfriendly){
            innerTemplate = '<img src="/assets/img/icons/petfriendly.svg" alt="Vector of a dog"><span class="u-visuallyHidden">Pet friendly</span>';
        } else {
            let contents = { "image" : image, "alt" : alttext, "title" : title, "number" : number };
            innerTemplate = util.template(facilityStr, contents);
        }

        let data = { "content" : innerTemplate, "tooltip": tooltip };
        return util.template(outerTemplateToUse, data);
    }


    function generateCarouselSlides(images, url){

        var carouselSlide = $('#searchListing-slide').html();
        var markup = "";

        $.each(images, function () {

            var self = this;
            var data = {
                "image" : self.Src,
                "imagealt": self.Caption,
                "url": url
            };

            var updatedString = util.template(carouselSlide, data);
            markup += updatedString;
        });

        return markup;
    }




    return {
        init: init,
        updateFilters: updateFilters,
        checkin: checkin,
        clearNights: clearNights
    };
})();
